

function ScorecardService($http, $state, ModelService, ApiUrl) {

    var scorecardUrl = ApiUrl.partial('scorecard'),
        configUrl    = scorecardUrl.partial('config'),
        sectionUrl   = configUrl.partial('section'),
        questionUrl  = configUrl.partial('question');

    this.loadConfig = loadConfig;
    this.loadScorecard = loadScorecard;
    this.createScorecard = createScorecard;
    this.resetScorecard = resetScorecard;
    this.deleteScorecard = deleteScorecard;
    this.patchScorecard = patchScorecard;
    this.report = report;
    this.getHistory = getHistory;

    this.loadSections = loadSections;
    this.patchSection = patchSection;
    this.deleteSection = deleteSection;
    this.createSection = createSection;
    this.loadSection = loadSection;
    this.loadQuestions = loadQuestions;
    this.patchOrder = patchOrder;
    this.createQuestion = createQuestion;

    this.indexConfigItem = indexConfigItem;
    this.getConfigItem = getConfigItem;
    this.patchConfigItem = patchConfigItem;
    this.deleteConfigItem = deleteConfigItem;
    this.patchOptions = patchOptions;

    function loadConfig() {
        return $http
            .get(ApiUrl('scorecard', 'config'))
            .then(unwrapData);
    }

    function loadScorecard(program) {
        return ModelService.get('scorecard', program.id);
    }

    function report(params) {
        return $http.get(ApiUrl('scorecard'), {params: params})
            .then(unwrapData)
    }

    function patchScorecard(scorecard, data) {
        return ModelService.patchModel(scorecard, data);
    }

    function createScorecard(program) {
        return ModelService.post('scorecard', {program_id: program.id});
    }

    function resetScorecard(program) {
        return ModelService.postRelation('scorecard', program.id, 'reset', {});
    }

    function deleteScorecard(program) {
        return ModelService.delete('scorecard', program.id);
    }

    function getHistory(scorecard) {
        return ModelService.getRelation('scorecard', scorecard.id, 'history')
    }

    function unwrapData(response) {
        return response.data;
    }

    function unwrapItem(response) {
        return response.data.item || response.data.items;
    }

    function copyInto(item) {
        return function(data) {
            angular.copy(data, item);
            return item;
        }
    }

    function indexConfigItem(type, params) {
        params = params || {};
        return $http.get(configUrl(type), {params: params})
            .then(unwrapItem);
    }

    function getConfigItem(type, id) {
        return $http.get(configUrl(type, id)).then(unwrapItem);
    }

    function patchConfigItem(type, model, data) {
        return $http.patch(configUrl(type, model.id), data)
            .then(unwrapItem)
            .then(copyInto(model));
    }

    function deleteConfigItem(type, model) {
        return $http.delete(configUrl(type, model.id));
    }

    function patchOptions(question, options) {
        var url = configUrl('question', question.id, 'options');
        return $http.patch(url, options)
            .then(unwrapItem)
            .then(copyInto(question));
    }


    function patchOrder(type, data) {
        return $http.patch(configUrl(type, 'order'), data)
            .then(unwrapItem);
    }

    function loadSections() {
        return $http.get(sectionUrl()).then(unwrapItem);
    }

    function loadSection(id) {
        return $http.get(sectionUrl(id)).then(unwrapItem);
    }

    function patchSection(section, data) {
        return $http.patch(sectionUrl(section.id), data)
            .then(unwrapItem)
            .then(copyInto(section));
    }

    function deleteSection(data) {
        return $http.delete(sectionUrl(data.id));
    }

    function createSection(data) {
        return $http.post(sectionUrl(), data).then(unwrapItem);
    }

    function createQuestion(data) {
        return $http.post(questionUrl(), data).then(unwrapItem);
    }

    function loadQuestions(sectionId) {
        return $http.get(questionUrl(), {params: {section_id: sectionId}})
            .then(unwrapItem);
    }

}

module.service('ScorecardService', ScorecardService);